import { render, staticRenderFns } from "./CreateApproval.vue?vue&type=template&id=8d0eea9c"
import script from "./CreateApproval.vue?vue&type=script&lang=js"
export * from "./CreateApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports